<template>
  <div class="inventory-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "productBase",
};
</script>
